var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M9.62,12L12,5.67L14.37,12M11,3L5.5,17H7.75L8.87,14H15.12L16.25,17H18.5L13,3H11Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }